export default defineAppConfig({
  ui: {
    colors: {
      primary: 'blue',
      secondary: 'green',
      neutral: 'zinc',
    },
    navigationMenu: {
      slots: {
        link: 'font-heading font-bold tracking-wider text-sm text-blue-50',
      },
    },
  },
  uiPro: {
    pageSection: {
      slots: {
        label: 'text-lg',
        title: 'font-heading text-blue-800 dark:text-blue-200',
      },
    },
    prose: {
      h1: {
        slots: {
          base: 'font-heading text-blue-800 dark:text-blue-200',
          link: 'text-blue-800 dark:text-blue-50',
        },
      },
      h2: {
        slots: {
          base: 'font-heading text-blue-800  dark:text-blue-50',
          link: 'text-blue-800  dark:text-blue-50',
        },
      },
      h3: {
        slots: {
          base: 'font-heading',
        },
      },
      h4: {
        slots: {
          base: 'font-heading',
        },
      },
      h5: {
        slots: {
          base: 'font-heading',
        },
      },
    },
  },

  folders: {
    sources: 'bronnen',
    investigation: 'onderzoek',
    locations: 'locaties',
    chapters: 'hoofdstukken',
  },

  contact: {
    phoneNumbers: [
      {
        label: 'Nederland',
        number: '+31641828627',
        formatted: '+31 (0)6-41828627',
        countryCode: 'nl',
      },
      {
        label: 'België',
        number: '+32475811022',
        formatted: '+32 (0) 475811022',
        countryCode: 'be',
      },
    ],
  },
})
